import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { HelpComponent } from "./helpComponent";

export const HelpModal: ComponentF<void> = (C) => {
  floodFill(C.display, C.bounds, Colors.BLACK);
  C.display.drawText(
    C.bounds.x + C.bounds.w / 2 - 26,
    C.bounds.y + C.bounds.h - 2,
    `%c{${Colors.RED_4}}Enter%c{} or %c{${Colors.RED_4}}Escape%c{} Close Help`
  );

  C.handlers.keypress = (key) => {
    if (key === "Enter" || key === "Escape") {
      closeModal();
    }
    return true;
  };

  return [
    createElement(HelpComponent, {
      x: 0,
      y: 0,
      w: C.bounds.w,
      h: C.bounds.h - 2,
    }),
  ];
};
